import { useEffect, useState } from 'react'

import { useTranslation } from 'utils/use-translation'

import { countDecimalPlaces } from '../../../../utils/count-decimal-places'
import { WalletType } from '../../../../store/fetchers/wallets/types'
import { floorNumber } from '../../../../utils/floor-number'

import { DashboardPieDescriptionProps } from './dashboard-pie-description.props'
import styles from './styles.module.scss'
import DashboardTableViewItem from './dashboard-table-view-item'

export default function DashboardPieDescription({ wallets }: DashboardPieDescriptionProps) {
  const { t } = useTranslation()

  const [sortedWallet, setSortedWallets] = useState<WalletType[]>([])
  const [otherPercent, setOtherPercent] = useState<number>(0)
  const [otherBalance, setOtherBalance] = useState<number>(0)
  const indicatorStyleNames = ['indicator_violet', 'indicator_yellow', 'indicator_green', 'indicator_gray']
  const [totalWalletAmount, setTotalWalletAmount] = useState<number>(0)

  useEffect(() => {
    if (wallets.length) {
      const amount = wallets.reduce((acc, cur) => {
        acc += +cur.balance * +cur.rate
        return acc
      }, 0)
      setTotalWalletAmount(floorNumber(amount, 2))
    }
  }, [wallets])

  useEffect(() => {
    if (wallets.length > 0 && totalWalletAmount) {
      calculateWalletsForTable()
    }
  }, [wallets, totalWalletAmount])

  const calculateWalletsForTable = () => {
    const sortedWallets = [...wallets].sort((a, b) => b.balance * +b.rate - a.balance * +a.rate)
    const balances = []
    const percents = []
    const walletsForTable = []
    for (let i = 0; i < sortedWallets.length; i++) {
      if (floorNumber(+(sortedWallets[i].balance * +sortedWallets[i].rate), 2) !== 0.0) {
        walletsForTable.push(sortedWallets[i])
        balances.push(sortedWallets[i].balance * +sortedWallets[i].rate)
        percents.push(
          countDecimalPlaces(((sortedWallets[i].balance * +sortedWallets[i].rate) / totalWalletAmount) * 100) > 2
            ? floorNumber(((sortedWallets[i].balance * +sortedWallets[i].rate) / totalWalletAmount) * 100, 2)
            : ((sortedWallets[i].balance * +sortedWallets[i].rate) / totalWalletAmount) * 100,
        )
      }
      if (
        i === 2 &&
        wallets.length > 3 &&
        floorNumber(+(sortedWallets[i].balance * +sortedWallets[i].rate), 2) !== 0.0
      ) {
        walletsForTable.push(sortedWallets[i])
        break
      }
    }

    if (wallets.length > 3) {
      const balancesSum = balances.reduce((acc, curr) => (acc += floorNumber(curr, 2)), 0)
      
      
      const otherBalance =
        countDecimalPlaces(totalWalletAmount - balancesSum) > 2
          ? floorNumber(totalWalletAmount - balancesSum, 2)
          : totalWalletAmount - balancesSum
      setOtherBalance(otherBalance)
      const percentsSum = percents.reduce((acc, curr) => (acc += curr), 0)
      const otherPercent =
        countDecimalPlaces(100 - percentsSum) > 2 ? floorNumber(100 - percentsSum, 2) : 100 - percentsSum
      setOtherPercent(otherPercent)
    }

    setSortedWallets(walletsForTable)
  }

  return (
    <div className={styles.table}>
      <div className={styles.row}>
        <small>{t('wallet')}</small>
        <small>{t('portfolio')}</small>
        <small>{t('balance')}</small>
        <small>{t('price_24h')}</small>
        <small>{t('rate')}</small>
      </div>

      {sortedWallet.length > 0 &&
        sortedWallet.map((item, index) => {
          return (
            <DashboardTableViewItem
              key={index}
              wallet={item}
              totalWalletBalance={totalWalletAmount}
              index={index}
              otherBalance={otherBalance}
              otherPercent={otherPercent}
              indicatorStyleName={indicatorStyleNames[index]}
            />
          )
        })}
    </div>
  )
}
